var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetProductsAsync as InvokeAsync , GetProductsSync as InvokeSync}

async function GetProductsAsync(LoginToken,LastKey)
{
    var GetProductsPromise = new Promise((resolve, reject) => {
        GetProductsSync(LoginToken,LastKey,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetProductsPromise;
}

function GetProductsSync(LoginToken,LastKey,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetProducts',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            LastKey   :LastKey,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
